export const META_PIXEL_VENDOR_ID = 'facebook';
export const SCRIPT_ID = 'meta-pixel-script';
export const SCRIPT_CONTENT =	`
	!function(f,b,e,v,n,t,s)
	{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
	n.callMethod.apply(n,arguments):n.queue.push(arguments)};
	if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
	n.queue=[];t=b.createElement(e);t.async=!0;
	t.src=v;s=b.getElementsByTagName(e)[0];
	s.parentNode.insertBefore(t,s)}(window, document,'script',
	'https://connect.facebook.net/en_US/fbevents.js');
	fbq('init', '840780364559150');`;
export const NO_SCRIPT_CONTENT = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=840780364559150&ev=PageView&noscript=1"/>`;
export const META_PIXEL_QUEUE_ID = 'meta-pixel';
